import createAsyncAction from "utils/createAsyncAction";

const page_size = 1000;

export const GET_GROUP_MEMBERS_REQUESTED = "GET_GROUP_MEMBERS_REQUESTED";
export const GET_GROUP_MEMBERS_SUCCEEDED = "GET_GROUP_MEMBERS_SUCCEEDED";
export const GET_GROUP_MEMBERS_FAILED = "GET_GROUP_MEMBERS_FAILED";
export const GET_DISABLED_USERS_REQUESTED = "GET_DISABLED_USERS_REQUESTED";
export const GET_DISABLED_USERS_SUCCEEDED = "GET_DISABLED_USERS_SUCCEEDED";
export const GET_DISABLED_USERS_FAILED = "GET_DISABLED_USERS_FAILED";
export const GET_GROUPS_REQUESTED = "GET_GROUPS_REQUESTED";
export const GET_GROUPS_SUCCEEDED = "GET_GROUPS_SUCCEEDED";
export const GET_GROUPS_FAILED = "GET_GROUPS_FAILED";
export const READ_USER_REQUESTED = "READ_USER_REQUESTED";
export const READ_USER_SUCCEEDED = "READ_USER_SUCCEEDED";
export const READ_USER_FAILED = "READ_USER_FAILED";
export const UPDATE_USER_REQUESTED = "UPDATE_USER_REQUESTED";
export const UPDATE_USER_SUCCEEDED = "UPDATE_USER_SUCCEEDED";
export const UPDATE_USER_FAILED = "UPDATE_USER_FAILED";
export const UPDATE_USER_IMAGE_REQUESTED = "UPDATE_USER_IMAGE_REQUESTED";
export const UPDATE_USER_IMAGE_SUCCEEDED = "UPDATE_USER_IMAGE_SUCCEEDED";
export const UPDATE_USER_IMAGE_FAILED = "UPDATE_USER_IMAGE_FAILED";

/**
 * An asynchronous action that gets all the users in the specified group
 * @param {String} group name
 */
export const getGroupMembersAsync = group => {
  return (dispatch, getState, getClient) => {
    const api = getClient(dispatch, getState);

    dispatch({
      type: GET_GROUP_MEMBERS_REQUESTED,
    });

    return api.users
      .list({ group, active: 1, page_size })
      .then(response => {
        return dispatch({
          type: GET_GROUP_MEMBERS_SUCCEEDED,
          payload: {
            group,
            ...response,
          },
        });
      })
      .catch(error => {
        return dispatch({
          type: GET_GROUP_MEMBERS_FAILED,
          payload: error,
          error: true,
        });
      });
  };
};

export const getDisabledUsersAsync = createAsyncAction(
  "users",
  "list",
  "GET_DISABLED_USERS",
  // @TODO: This query is not correct. These users are not disabled.
  // We're removing invocations of this action until we have a way to list users that have had privleges revoked.
  () => ({
    active: 0,
    page_size,
  }),
  err => err
);

// Doesn't use createAsyncAction because this action triggers others in a chain and must resolve with data
export const getGroupsAsync = () => {
  return (dispatch, getState, getClient) => {
    const api = getClient(dispatch, getState);

    dispatch({
      type: GET_GROUPS_REQUESTED,
    });

    return api.groups
      .list()
      .then(groups => {
        dispatch({
          type: GET_GROUPS_SUCCEEDED,
          payload: groups,
        });

        // Return the groups for a chained async action to use without waiting for reducer
        return groups.results;
      })
      .catch(error => {
        dispatch({
          type: GET_GROUPS_FAILED,
          payload: error,
          error: true,
        });
      });
  };
};

// Note that the "user id" is their username, not their UUIDv4
export const readUserAsync = createAsyncAction("users", "read", "READ_USER");

export const updateUserAsync = createAsyncAction(
  "users",
  "update",
  "UPDATE_USER",
  args => args,
  error => {
    throw error;
  }
);

export const createUserAsync = createAsyncAction(
  "users",
  "create",
  "CREATE_USER",
  args => args,
  error => {
    throw error;
  }
);

export const updateUserImageAsync = createAsyncAction(
  "users",
  "update",
  "UPDATE_USER_IMAGE",
  ([username, image]) => [username, { photo: image }],
  error => {
    throw error;
  }
);
